












































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import {
  CreatorService,
  CreatorServiceCategory,
  InputCreatorServiceSearch,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { EVENTS } from "@/const";
import { QuickTip } from "@/types";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import QuickTipsItem from "@/components/QuickTipsItem";
import CreatorServiceListModal from "./CreatorServiceListModal.vue";
import { useCreatorServices } from "../hooks/useCreatorServices";
import useCreatorServicesPurchase from "../hooks/useCreatorServicesPurchase";

export default defineComponent({
  name: "CreatorServicePurchaseModal",
  components: {
    PaymentConfirmation,
    QuickTipsItem,
    BaseAvatar,
    BaseButton,
    CreatorServiceListModal,
  },
  props: {
    userId: { type: String, required: true },
    user: { type: Object as PropType<UserWithAvatar>, default: null },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const purchasing = ref(false);
    const itemToPurchase = ref<CreatorService | null>(null);
    const selectedFilter = ref<CreatorServiceCategory | "">("");
    const warning: QuickTip = {
      icon: "sci-information-outline",
      translateKey: "Refundable credits if delivery does not occur within 24 hours (subject to verification)",
      type: "info",
    };

    const searchData = computed<InputCreatorServiceSearch>(() => ({
      userId: props.userId,
      categories: selectedFilter.value ? [selectedFilter.value] : undefined,
      sort: "ID,DESC",
    }));

    const { items, enableScroll, totalRecords, getFirstPage, getNextPage } = useCreatorServices(searchData);

    const { purchase, purchaseInfoDetails } = useCreatorServicesPurchase(itemToPurchase);

    const onUnlock = (item: CreatorService) => {
      if (purchasing.value) return;
      itemToPurchase.value = item;
    };

    const onPurchase = useAuthorisedOnly(async () => {
      try {
        purchasing.value = true;
        const { success } = await purchase();
        if (success) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, {
            text: $t("Thank you for your purchase"),
            position: "top",
          });
          itemToPurchase.value = null;
          emit("close");
        }
      } finally {
        purchasing.value = false;
      }
    });

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    watch(
      selectedFilter,
      () => {
        getData();
      },
      { immediate: true }
    );

    return {
      loading,
      enableScroll,
      items,
      purchasing,
      purchaseInfoDetails,
      selectedFilter,
      itemToPurchase,
      totalRecords,
      warning,
      onUnlock,
      onPurchase,
      getNextPage,
      formatMoneyString,
    };
  },
});
